export const BASE_URL = 'https://res.cloudinary.com/gumtree/image/upload';
export const IMAGES_SIZES = [
    {
        imageId: 14,
        width: 64,
        height: 64
    },
    {
        imageId: 0,
        width: 96,
        height: 96
    },
    {
        imageId: 2,
        width: 200,
        height: 200
    },
    {
        imageId: 35,
        width: 300,
        height: 300
    }
];
export const FALLBACK_IMAGE_ID = 35;
